import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useMemo, useRef } from 'react';
import { Tooltip } from 'react-tippy';
import { PROFFIT_SEARCH_ACTION_TOOLTIP_BLOCK_SHARE, PROFFIT_SEARCH_ACTION_TOOLTIP_LIMITED_STANDARD_PLAN, } from '../../../../../define/consts/proffit_search/proffit_search_service';
import OtherClickListener from '../../../../../events/OtherClickListener';
import { propArrayShape, propArrayStr, propBool, propFunc, propStr, propNumber, propShape, } from '../../../../../helpers/custom-prop-types';
import { useBoolState, useFunctionSetAfterCall, useUnmountRef, } from '../../../../../helpers/use/useHook';
import LockIcon from '../../../../Icon/Svg/LockIcon';
import SharePeopleIcon from '../../../../Icon/Svg/SharePeopleIcon';
import HtmlLink from '../../../../Ui/Common/HtmlLink';
import ModalPortal from '../../../../Ui/Modal/ModalPortal';
import Hover from '../../../../Ui/System/Hover';
import ActionShare from './ActionShare';
const ActionShareButton = (props) => {
    const { buttonClassName, className, enableDomains, isBlockShare, isFree, noShareMemberOptionsMessage, onClickLockItem, onLoadShareMemberOptions, onSubmitShare, position, profile, select2TooltipZIndex, selectSlides, showBg, } = props;
    const { boolState, changeFalse, changeToggle } = useBoolState(false);
    const ref = useRef();
    const unmountRef = useUnmountRef();
    useEffect(() => {
        const index = OtherClickListener.setListener(ref.current, changeFalse);
        return () => OtherClickListener.deleteListener(index);
    }, [ref, changeFalse]);
    const onSubmit = useFunctionSetAfterCall(onSubmitShare, changeFalse);
    const initialValues = useMemo(() => ({
        slides: selectSlides,
    }), [selectSlides]);
    const modals = (_jsx(ActionShare, { className: className, enableDomains: enableDomains, hideForm: changeFalse, initialValues: initialValues, isShow: boolState, noShareMemberOptionsMessage: noShareMemberOptionsMessage, onLoadShareMemberOptions: onLoadShareMemberOptions, onSubmit: onSubmit, profile: profile, showBg: showBg, tooltipZIndex: select2TooltipZIndex, unmountRef: unmountRef }));
    return (_jsxs("div", Object.assign({ className: 'slide_action_button_box', ref: ref }, { children: [_jsx(Hover, { children: _jsxs("div", Object.assign({ className: 'slide_action_button_box_content' }, { children: [(isBlockShare || isFree) && (_jsx("div", Object.assign({ className: 'slide_action_button_lock' }, { children: _jsx(Tooltip, Object.assign({ animation: 'scale', arrow: true, disabled: !isBlockShare && !isFree, duration: 100, html: isBlockShare
                                    ? PROFFIT_SEARCH_ACTION_TOOLTIP_BLOCK_SHARE
                                    : PROFFIT_SEARCH_ACTION_TOOLTIP_LIMITED_STANDARD_PLAN, position: position === 'right' ? 'left-start' : 'top', zIndex: 1011 }, { children: isBlockShare || isFree ? (_jsx(LockIcon, {})) : (_jsx(HtmlLink, Object.assign({ isNoLinkComponent: onClickLockItem ? 'button' : undefined, onClick: onClickLockItem, to: '/proffit_search/account_plan' }, { children: _jsx(LockIcon, {}) }))) })) }))), _jsx("button", Object.assign({ className: clsx('icon_box', buttonClassName), disabled: isBlockShare || isFree, onClick: changeToggle, type: 'button' }, { children: _jsx(SharePeopleIcon, {}) })), _jsx("span", Object.assign({ className: 'button_text' }, { children: "\u5171\u6709" }))] })) }), className === 'footer_action_share_modal' ? (_jsx(ModalPortal, { children: modals })) : (modals)] })));
};
ActionShareButton.propTypes = {
    buttonClassName: propStr().isRequired,
    className: propStr().isRequired,
    enableDomains: propArrayStr().isRequired,
    isBlockShare: propBool().isRequired,
    isFree: propBool().isRequired,
    noShareMemberOptionsMessage: propFunc().isRequired,
    onClickLockItem: propFunc().isRequired,
    onLoadShareMemberOptions: propFunc().isRequired,
    onSubmitShare: propFunc().isRequired,
    position: propStr().isRequired,
    profile: propShape().isRequired,
    select2TooltipZIndex: propNumber(),
    selectSlides: propArrayShape().isRequired,
    showBg: propBool(),
};
ActionShareButton.defaultProps = {
    select2TooltipZIndex: undefined,
    showBg: false,
};
export default ActionShareButton;
